<template>
    <div v-if="showModal" id="product_counter" class="ui middle aligned center aligned grid">
        <div class="ui column segments">
            <!-- <div id="header" class="ui left aligned segment">
                <h3 class="ui header">{{ }}</h3>
            </div> -->
            <div id="body" class="ui segment">
                <div class="ui form">
                    <div class="field">
                        <h4 class="ui aligned header">{{ minDate.format("yyyy년 MM월 dd일") }} ~ {{ maxDate.format("yyyy년 MM월 dd일") }}</h4>
                        <h4 class="ui aligned header">{{ "전체건수: " + itemCount }}</h4>
                        <div class="ui grid">
                            <div class="row">
                                    <div class="eleven wide column">
                                        <table class="ui celled compact table" v-for="(data) in dataArray" :key="data.partnerName">
                                            <thead>
                                                <tr>
                                                    <th colspan="2">{{ data.partnerName }}</th>
                                                </tr>
                                            </thead>
                                            <tbody v-for="(product) in data.products" :key="product.name">
                                                <tr>
                                                    <td>{{ product.name }}</td>
                                                    <td class="collapsing">{{ product.count }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="five wide column">
                                        <table class="ui celled table">
                                            <thead>
                                                <tr>
                                                    <th>서명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><br><br></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="footer" class="ui right aligned segment">
                <div class="ui form">
                    <div class="inline field">
                        <div class="ui button" @click="close">닫기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: function() {
        return { showModal: 0, dataArray: 0, minDate: 0, maxDate: 0, itemCount: 0, }
    },
    created: function() {
        this.showModal = false;
    },
    mounted: function() {
        window.addEventListener('keyup', (e) => { if (this.showModal && e.keyCode === 27) this.close(); });
        this.$event.set("open_product_counter", this.open);
    },
    beforeDestroyed: function() {
        this.$event.clear("open_product_counter");
    },
    methods: {
        open(items) {
            this.showModal = true;
            this.minDate = "";
            this.maxDate = "";
            this.itemCount = 0;

            const partners = {};
            for (const item of items)
            {
                if (item.isTerminated) conitnue;

                this.itemCount += 1;

                if (!partners[item.partnerName]) partners[item.partnerName] = {};
                if (!partners[item.partnerName][item.product]) partners[item.partnerName][item.product] = 0;
                partners[item.partnerName][item.product] += item.count;

                const date = new Date(item.createdAt);
                if (!this.minDate || date.getTime() < this.minDate.getTime()) { this.minDate = date; }
                if (!this.maxDate || date.getTime() > this.maxDate.getTime()) { this.maxDate = date; }
            }

            this.dataArray = [];
            for (const partnerName in partners) {

                const data = {};
                data.partnerName = partnerName;
                data.products = [];
                for (const productName in partners[partnerName]) {
                    data.products.push({
                        name: productName,
                        count: partners[partnerName][productName],
                    });
                }
                this.dataArray.push(data);
            }
        },
        close() {
            this.showModal = false;
        },
    },
}
</script>

<style>

#product_counter {
    position: fixed;
    left: 0;
    top: 0;
    margin: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.8);
}

#product_counter .column {
    max-width: 600px;
}

#product_counter #header {
    padding: 20px 30px;
}

#product_counter #body {
    padding: 0;
}

#product_counter #footer {
    padding: 20px 20px;
    background-color: #eee;
}

#product_counter #footer .ui.form {
    padding: 0;
}

#product_counter .ui.form {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductModal_Counter.vue